module.exports = __webpack_public_path__ + "img/entia-portafolio-energia-carrusel-1.9afe8263.webp";